import UserContorl from '@/admin/userContorl/index.vue'
import AdminView from '../components/main/admin.vue'

const routes = [
  {
    path: '/admin/',
    component: AdminView,
    meta: {
      title: '管理员',
      icon: 'lock',
      roles: ['root','admin'] // you can set roles in root nav
    },
    children: [
      {
        hidden: false,
        path: '/',
        name: 'UserContorl',
        component: UserContorl,
        meta: {
          title: '用户管理',
          icon: 'lock',
          roles: ['root','admin'] // you can set roles in root nav
        },
      },
      {
        hidden: false,
        path: 'videoContorl',
        name: 'VideoContorl',
        component: resolve => require(['@/admin/videoContorl/index'], resolve),
        meta: {
          title: '视频管理',
          icon: 'lock',
          roles: ['root'] // you can set roles in root nav
        },
      },
      {
        hidden: false,
        path: 'processContorl',
        name: 'ProcessContorl',
        component: resolve => require(['@/admin/processContorl/index'], resolve),
        meta: {
          title: '学习记录',
          icon: 'lock',
          roles: ['root','admin'] // you can set roles in root nav
        },
      },
      {
        hidden: false,
        path: 'pagerContorl',
        name: 'PagerContorl',
        component: resolve => require(['@/admin/pagerContorl/index'], resolve),
        meta: {
          title: '试卷管理',
          icon: 'lock',
          roles: ['root'] // you can set roles in root nav
        },
      },
      {
        hidden: false,
        path: 'answerContorl',
        name: 'AnswerContorl',
        component: resolve => require(['@/admin/answerContorl/index'], resolve),
        meta: {
          title: '考试记录',
          icon: 'lock',
          roles: ['root','admin'] // you can set roles in root nav
        },
      },
      {
        hidden: true,
        path: 'editPager/:id/:pagerId',
        name: 'EditPager',
        component: resolve => require(['@/admin/editPager/index.vue'], resolve),
        meta:{
          title: '试卷页面',
          roles: ['root']
        }
      },
      {
        hidden: false,
        path: 'settingsControl',
        name: 'SettingsControl',
        component: resolve => require(['@/admin/settingsControl/index'], resolve),
        meta: {
          title: '基础配置',
          icon: 'lock',
          roles: ['root'] // you can set roles in root nav
        },
      },
    ],
  },
];

export default routes;